<div class="duvida-item">
      <div class="header" (click)="_show()">
            <span>{{data.titulo}}</span>
            <div class="icon">
                  <img src="/images/template/icons/arrow.svg" alt="Arrow" width="20px" />
            </div>      
      </div>
      <div class="content wow fadeIn" *ngIf="show">
            <article class="text-article-html" [innerHtml]="data.texto | safeHtml"></article>
      </div>      
</div>      
